import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

const config = require('../branding/branding.json');
let logo;
if (!config.logoExternal) {
    logo = require(`../${config.logoUrl}`);
} else {
    logo = config.logoUrl;
}

import './Sidebar.css';
import brandingStyles from '../branding/brandingStyles';

// Since logo is only present there, defining layout style here
const logoStyle = {
    maxWidth: '220px',
    margin: '10px',
};

class SidebarComponent extends Component {
    render() {
        return (
            <div
              className="navbar-default sidebar"
              role="navigation"
              style={brandingStyles.backgrounds.menu}
            >
                <div className="sidebar-nav navbar-collapse">
                    <Link to="/users">
                      <img src={logo} style={logoStyle} alt="Scality logo">
                      </img>
                    </Link>
                    <ul className="nav" id="side-menu">
                        <li>
                            <NavLink to="/users"
                              exact
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-user-circle">
                                </i> Users
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                              to="/users/groups"
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-users">
                                </i> Groups
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                              to="/users/policies"
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-key">
                                </i> Policies
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                              to="/users/account-metrics"
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-line-chart">
                                </i> Account metrics
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                              to="/users/buckets"
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-archive">
                                </i> Buckets
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default SidebarComponent;



/** WEBPACK FOOTER **
 ** ./src/components/Sidebar.js
 **/